var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.658,
    height: 24.658,
    viewBox: "0 0 24.658 24.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com",
    d: "M10.819,6.2C12.381,3.4,13.161,2,14.329,2s1.948,1.4,3.51,4.2l.4.725a4.523,4.523,0,0,0,1.012,1.457,4.214,4.214,0,0,0,1.638.555l.785.178c3.032.686,4.549,1.029,4.909,2.189s-.673,2.369-2.74,4.786l-.535.625A4.538,4.538,0,0,0,22.3,18.173a4.736,4.736,0,0,0,0,1.8l.081.834c.313,3.225.469,4.838-.476,5.555s-2.364.063-5.2-1.244l-.735-.338a4.206,4.206,0,0,0-1.638-.557,4.206,4.206,0,0,0-1.638.557l-.735.338c-2.839,1.307-4.259,1.961-5.2,1.244s-.788-2.33-.476-5.555l.081-.834a4.733,4.733,0,0,0,0-1.8,4.537,4.537,0,0,0-1.013-1.455l-.535-.625c-2.067-2.417-3.1-3.626-2.74-4.786S3.948,9.8,6.98,9.116l.785-.178A4.215,4.215,0,0,0,9.4,8.384a4.523,4.523,0,0,0,1.012-1.457Z",
    transform: "translate(-2 -2)",
    fill: "#dedfe1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.99af841493805fba218ee4df7eca9721.svg";
export { ForwardRef as ReactComponent };